module.exports = __webpack_public_path__ + "static/img/ESPN_kia_port_lg.0f690ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/kia-tip-off-challenge-banner-campaign/ESPN_kia_port_lg.jpg
// module id = 250
// module chunks = 2